import React from "react";
import { SELECTED_ELEMENT_COLOR, defaultObjectSizes, OBJECT_TYPES, INITIAL_PPM } from "../configuratorConstants";
import { ReactComponent as LedSvg } from '../../Assets/led.svg';

const CeilingLightRenderer = ({
  element,
  scale,
  isSelected,
}) => {
  const lightDefaults = defaultObjectSizes[OBJECT_TYPES.LIGHT_CEILING];
  
  const elIntrinsicWidthM = element.width || lightDefaults.width;
  const elIntrinsicHeightM = element.height || lightDefaults.height;

  const isElementRotatedOnPlan = Math.abs(element.rotation || 0) % 180 === 90;

  const ledSvgComponentWidthPx = elIntrinsicHeightM * scale;
  const ledSvgComponentHeightPx = elIntrinsicWidthM * scale;

  let ledSvgTransform = "";
  if (!isElementRotatedOnPlan) {
    ledSvgTransform = "rotate(90)";
  }

  const invScaleFactor = 1;

  const svgStyle = {
    fill: isSelected ? "rgba(0, 123, 255, 0.15)" : "rgba(229, 231, 235, 0.8)", 
    stroke: isSelected ? SELECTED_ELEMENT_COLOR : "rgba(107, 114, 128, 0.6)", 
    strokeWidth: (isSelected ? 1.0 : 0.5) * invScaleFactor,
    transition: "fill 0.15s ease-in-out, stroke 0.15s ease-in-out",
  };

  const baseFontSize = 6;
  const minFontSize = 3;
  const maxFontSize = 8;
  const labelFontSize = Math.max(minFontSize, Math.min(maxFontSize, baseFontSize * invScaleFactor));

  const textStyle = {
    fontSize: `${labelFontSize}px`,
    fill: "rgba(55, 65, 81, 1)", 
    textAnchor: "middle",
    dominantBaseline: "central",
    pointerEvents: "none",
    userSelect: "none",
    fontFamily: "Arial, sans-serif",
  };
  
  return (
    <g> 
      <g transform={ledSvgTransform}>
        <LedSvg
          x={-ledSvgComponentWidthPx / 2} 
          y={-ledSvgComponentHeightPx / 2}
          width={ledSvgComponentWidthPx}
          height={ledSvgComponentHeightPx}
          preserveAspectRatio="xMidYMid meet" 
          style={svgStyle}
        />
      </g>
      
      {element.label && (
          <text
            x="0" 
            y="0" 
            style={textStyle}
          >
            {element.label}
          </text>
        )}
    </g>
  );
};

export default React.memo(CeilingLightRenderer);